import { AmbientLight } from 'three';
export default () => {
    const light = new AmbientLight();
    return light;
};
